import React, { useState } from 'react';
import { Box, Chip } from '@mui/material';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import './ChipInput.css'; 

const isValidPhone = (phone) => {
  const trimmed = phone.trim();
  const validPrefixes = ['+212', '+33', '+216']; 
  return (
    validPrefixes.some(prefix => trimmed.startsWith(prefix)) &&
    /^\+?[0-9\s\-()]{6,}$/.test(trimmed)
  );
};

const PhoneChipInput = ({ label, values = [], onChange, error, helperText }) => {
  const [currentPhone, setCurrentPhone] = useState('');
  const [localError, setLocalError] = useState('');

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      const trimmed = currentPhone.trim();

      if (!isValidPhone(trimmed)) {
        setLocalError('Numéro invalide (autorisé : +212, +33, +216)');
        return;
      }

      if (!values.includes(trimmed)) {
        onChange([...values, trimmed]);
        setCurrentPhone('');
        setLocalError('');
      }
    }
  };

  const handleDelete = (phone) => {
    onChange(values.filter((p) => p !== phone));
  };

  return (
    <Box className="chip-input-container">
      <label>{label}</label>
      <PhoneInput
        country="fr"
        onlyCountries={['fr', 'ma', 'tn']} 
        value={currentPhone}
        onChange={(value, data) => {
            const fullNumber = `+${value}`;
            setCurrentPhone(fullNumber);
            if (localError && isValidPhone(fullNumber)) {
              setLocalError('');
            }
          }}          
        inputProps={{
          onKeyDown: handleKeyDown,
        }}
        inputStyle={{ width: '100%' }}
      />
      <Box className="chip-list" sx={{ mt: 1, display: 'flex', flexWrap: 'wrap', gap: 1 }}>
        {values.map((phone, idx) => (
          <Chip key={idx} label={phone} onDelete={() => handleDelete(phone)} />
        ))}
      </Box>
      {(error || localError) && (
        <p style={{ color: 'red' }}>{localError || helperText}</p>
      )}
    </Box>
  );
};

export default PhoneChipInput;
